import { render } from "./IllegalReportView.vue?vue&type=template&id=26159028"
import script from "./IllegalReportView.vue?vue&type=script&lang=js"
export * from "./IllegalReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__